<template>            
    <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
            <v-text-field
                outlined
                label="Nombre"
                v-model="datosEmpresa.nombre"
                v-validate="'required'"
                data-vv-name="Nombre"
                :error-messages="errors.collect('Nombre')"
            ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
            <v-text-field
                outlined
                label="Razon Social"
                v-model="datosEmpresa.razon_social"
                required
                v-validate="'required'"
                data-vv-name="Razon Social"
                :error-messages="errors.collect('Razon Social')"
            ></v-text-field>
        </v-col>

        <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
            <v-text-field
                outlined
                label="RFC"
                v-model="datosEmpresa.rfc"
                required
                id="RFC"
                maxlength="18"
                v-validate="'required|rfc'"
                data-vv-name="RFC"
                :error-messages="errors.collect('RFC')"
            ></v-text-field>
        </v-col>

        <v-col xs="12" sm="6" md="4" class="py-0">
            <v-text-field
                outlined
                label="Código postal"
                v-model="busca_cp"
                v-validate="'required'"
                data-vv-name="Código postal"
                :error-messages="errors.collect('Código postal')"
                @keyup.enter="busca_codigos()"
                v-on:keydown.tab="busca_codigos()"
                v-mask="'#####'"
            />
        </v-col>

        <v-col xs="12" sm="6" md="4" class="py-0">
            <v-text-field
                outlined
                label="Estado"
                v-model="estado"
                disabled
            />
        </v-col>

        <v-col xs="12" sm="6" md="4" class="py-0">
            <v-text-field
              outlined
              label="Municipio"
              v-model="municipio"
              disabled
            />
        </v-col>

        <v-col xs="12" sm="6" md="8" class="py-0">
            <v-text-field
                outlined
                label="Dirección"
                v-model="datosEmpresa.direccion"
                required
                v-validate="'required'"
                data-vv-name="Dirección"
                :error-messages="errors.collect('Dirección')"
            />
        </v-col>

        <v-col cols="12" xs="12" sm="4" md="4" class="py-0">
            <v-autocomplete
                outlined
                :items="colonias"
                item-text="nombre"
                item-value="id"
                label="Colonia"
                persistent-hint
                v-model="datosEmpresa.colonia_id"
                v-validate="'required'"
                data-vv-name="Colonia"
                :error-messages="errors.collect('Colonia')"
            />
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
            <v-text-field 
                outlined 
                label="Calle" 
                class="pa-0 ma-0" 
                v-model="datosEmpresa.calle" 
                v-validate="'required'"
                data-vv-name="Calle"
                :error-messages="errors.collect('Calle')"
            >                                                
            </v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
            <v-text-field 
                outlined 
                label="Número interior" 
                class="pa-0 ma-0" 
                v-model="datosEmpresa.interior"
                v-validate="'required'"
                data-vv-name="Número interior"
                :error-messages="errors.collect('Número interior')"
            >                                            
            </v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
            <v-text-field
                outlined
                label="Teléfono" 
                v-mask="'(###) ###-####'"
                v-model="datosEmpresa.telefono_contacto" 
                v-validate="'required'"
                data-vv-name="Teléfono"
                :error-messages="errors.collect('Teléfono')"
            ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
            <v-text-field 
                outlined 
                label="Apoderado" 
                class="pa-0 ma-0" 
                v-model="datosEmpresa.apoderado" 
                v-validate="'required'"
                data-vv-name="Apoderado"
                :error-messages="errors.collect('Apoderado')"
            >                                               
            </v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
            <v-text-field
                outlined
                label="URL de Servidor"
                v-model="datosEmpresa.url_server_asp"
                required
                v-validate="'https_puerto'"
                data-vv-name="URL de Servidor"
                :error-messages="errors.collect('URL de Servidor')"
            ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
            <v-textarea
                outlined
                label="Actividad comercial"
                v-model="datosEmpresa.actividad_comercial"
                v-validate="'required'"
                data-vv-name="Actividad comercial"
                :error-messages="errors.collect('Actividad comercial')"
                rows="3"
            ></v-textarea>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
            <v-textarea
                v-model="datosEmpresa.direccion_contrato"
                outlined
                label="Dirección contrato"
                rows="3"
                v-validate="'required'"
                data-vv-name="Dirección contrato"
                :error-messages="errors.collect('Dirección contrato')"
            ></v-textarea>
        </v-col>
        <!-- <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <v-divider></v-divider>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="pt-5">
            <p class="subtitulo">Datos Fiscales</p>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
            <v-text-field
                outlined
                label="Representante legal"
                v-model="datosEmpresa.representante_legal"
                v-validate="'required'"
                data-vv-name="Representante legal"
                :error-messages="errors.collect('Representante legal')"
            ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
            <v-autocomplete
                outlined
                label="Método de pago"
                :items="metodosPagos"
                item-text="nombre"
                item-value="id"
                persistent-hint
                v-model="datosEmpresa.metodo_de_pago_id"
                class="pa-0 ma-0"
                v-validate="'required'"
                data-vv-name="Método de pago"
                :error-messages="errors.collect('Método de pago')"
            >
            </v-autocomplete>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
            <v-autocomplete
                outlined
                label="Banco"
                :items="bancos"
                item-text="nombre"
                item-value="id"
                persistent-hint
                v-model="datosEmpresa.banco_empresa_f_id"
                class="pa-0 ma-0"
                v-validate="'required'"
                data-vv-name="Banco"
                :error-messages="errors.collect('Banco')"
            >
            </v-autocomplete>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
            <VuetifyDatePicker
                outlined
                v-model="datosEmpresa.inicio_operaciones"
                label="Inicio de operaciones"
                placeholder="dd/mm/aaaa"
                ref="FechaInicioOperaciones"
            />
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                <VuetifyDatePicker
                    outlined
                    v-model="datosEmpresa.fecha_contrato"
                    label="Fecha de contrato"
                    placeholder="dd/mm/aaaa"
                    ref="FechaInicioContrato"
                />
        </v-col> -->
    </v-row>
</template>

<script>
    import catalogosApi from "../api/catalogos";
    import Swal from "sweetalert2";
    import Notify from "@/plugins/notify";
    import VuetifyDatePicker from '@/components/VuetifyDatePicker.vue';
    import apiBancos from "@/api/bancos";
    import apiMetodoPago from "@/api/metodoPago";
    export default {
        name:'pop-empresa',
        props:{
            oyente:{
                type:Boolean,
                default:false
            },
            reset:{
                type:Boolean,
                default:false,
            }
        },
        components: {
            VuetifyDatePicker
        },
        data(){
            return{
                rol:null,
                estado_id:null,
                datosLogin:null,
                datosEmpresa:{
                    id                  : 0,
                    nombre              : null,
                    razon_social        : null,
                    rfc                 : null,
                    direccion           : null,
                    estado_id           : null,
                    municipio_id        : null,
                    cp_id               : null,
                    colonia_id          : null,
                    url_server_asp      : null,
                    empresa_id          : null,
                    cliente_id          : null,
                    formValidate        : false,
                    state               : '',
                    tipo                : 'gdth',
                    status              : 'tEmpresa',
                    telefono_contacto   : null,
                    representante_legal : null,
                    metodo_de_pago_id   : null,
                    banco_empresa_f_id  : null,
                    inicio_operaciones  : null,
                    fecha_contrato      : null,
                    calle               : null,
                    interior            : null,
                    apoderado           : null,
                    actividad_comercial : null,
                    direccion_contrato  : '',
                },
                estados         : [],
                ciudades        : [],
                colonias        : [],   
                busca_cp        : "",
                municipio       : "",
                estado          : "",
                bancos          : [],
                metodosPagos    : [],
            }
        },
        watch:{
            oyente: function(val){          
                if(val){
                    this.recopilaDatos();
                }
            },
            estado_id: function(val){
                this.cambioEstado(val);
            },
            'datosEmpresa.calle':function(val){
                this.formatoDireccionContrato();
            },
            'datosEmpresa.interior':function(val){
                this.formatoDireccionContrato();
            },
            'datosEmpresa.colonia_id':function(val){
                this.formatoDireccionContrato();
            },
            'estado':function(val){
                this.formatoDireccionContrato();
            },
            'municipio':function(val){
                this.formatoDireccionContrato();
            },
            busca_cp: function(val){
                if(val.length == 5){
                    this.busca_codigos();
                    this.formatoDireccionContrato();
                }
                else{
                    this.estado = "";
                    this.municipio = "";
                    this.colonias = [];
                }
            },
            reset: function(val){
                if(val){
                    this.resetValues();
                    this.getEstados();
                }
            }
        },
        methods:{
            formatoDireccionContrato(){
                let colonia = this.colonias.find(element => element.id == this.datosEmpresa.colonia_id);
                let nombreColonia = "";
                if(colonia != undefined){
                    nombreColonia = colonia.nombre!=undefined ? colonia.nombre : '';
                }
                this.datosEmpresa.direccion_contrato = ("CALLE "+this.datosEmpresa.calle + " NÚMERO " + this.datosEmpresa.interior + " DE LA COLONIA " + nombreColonia + " CÓDIGO POSTAL " + this.busca_cp + " " + this.municipio + ", " + this.estado).toUpperCase()
                
            },
            recopilaDatos(){
                this.$validator.validate().then(result => {
                    if (!result) {
                        this.$emit("resetValorGuardar"); 
                        return;
                    }
                    if(result){     
                        this.datosEmpresa.formValidate = (this.datosEmpresa.formValidate) ? false : this.datosEmpresa.formValidate;            
                    }
                    else{
                        this.datosEmpresa.formValidate = true;
                    }

                    if(this.rol == "admin"){
                        this.datosEmpresa.cliente_id = this.datosLogin.cliente_id;
                    }
                    this.$emit("save",this.datosEmpresa);              
                });
            },
            resetValues(){
                this.datosEmpresa={
                    nombre              : null,
                    razon_social        : null,
                    rfc                 : null,
                    direccion           : null,
                    estado_id           : null,
                    municipio_id        : null,
                    cp_id               : null,
                    colonia_id          : null,
                    url_server_asp      : null,
                    empresa_id          : null,
                    cliente_id          : null,
                    formValidate        : false,
                    status              : 'tEmpresa',
                    tipo                : 'gdth',
                    telefono_contacto   : null,
                    representante_legal : null,
                    metodo_de_pago_id   : null,
                    banco_empresa_f_id  : null,
                    inicio_operaciones  : null,
                    fecha_contrato      : null,
                    calle               : null,
                    interior            : null,
                    apoderado           : null,
                    actividad_comercial : null,
                    direccion_contrato  : '',
                };
                this.busca_cp = "";
            },
            getEstados(estado = null){
                let self = this;
                let parametros = {
                    paginate:false,
                    activo:true,
                    order:'asc'
                }

                catalogosApi.getEstados(parametros).then((response) => {
                    self.estados = response.data;
                }).catch(err => {
                    this.respuesta_error(err);
                });
            },
            cambioEstado(id, ciudad=null){
                let parametros = { activo:true, paginate: false, estado_id: id, order: 'asc'}
                catalogosApi.getCiudades(parametros).then((response)=>{
                    this.ciudades = response.data;
                })
                .catch(err => {
                    this.respuesta_error(err);
                });
            },
            respuesta_error(error){
                this.loading_guardar= false;
                    Swal.fire({
                    position: 'center',
                    type: 'error',
                    title: "Error",
                    text: error.response.data.message,
                    showConfirmButton: true,
                }) 
            },
            busca_codigos() {
                let self = this;
                let params = {
                    activo: true,
                    nombre: this.busca_cp,
                    include_padres: true,
                };
                catalogosApi.getCP(params).then((response) => {
                    let result = response.data;

                    if (result.length == 0) {
                        Notify.ErrorToast("No se encontro el Código postal.");
                        this.estado = "";
                        this.municipio = "";
                        this.colonias = [];
                        return;
                    }
                    this.estado = result[0].nomb_estado;
                    this.municipio = result[0].nomb_mun;
                    this.datosEmpresa.estado_id = result[0].estado_id;
                    this.datosEmpresa.municipio_id = result[0].municipio_id;
                    this.datosEmpresa.cp_id = result[0].id;

                    catalogosApi.getColonias({ codigo_postal_id: result[0].id, order: "asc", paginate: false }).then((response) => {
                        self.colonias = response.data;
                    })
                    .catch((e) => {
                        Notify.ErrorToast("Se presento un problema al cargar las colonias.");
                        return;
                    });
                })
                .catch((e) => {
                    console.log(e);
                    Notify.ErrorToast("Ocurrió un error al cargar los estados y ciudades.");
                });
            },
            async getCP(id) {
                await catalogosApi.getCodigoPostal(id).then((response) => {
                    this.busca_cp = response.nombre;
                    this.busca_codigos();
                })
                .catch((err) => {
                    console.error(err);
                    Notify.ErrorToast("Ocurrió un error al cargar los códigos postales.");
                });
            },
            getBancos(){
                let parametros = { activo:true, paginate:false, order:"asc" }
                apiBancos.find(parametros).then((response) => {
                    this.bancos = response.data;
                })
                .catch(err => {
                    console.log(err);
                    Notify.ErrorToast("Ocurrió un error al cargar los Bancos.");
                });
            },
            getMetodosPagos(){
                let parametros = { activo:true, paginate:false, order:"asc" }
                apiMetodoPago.find(parametros).then((response) => {
                    this.metodosPagos = response.data;
                })
                .catch(err => {
                    console.log(err);
                    Notify.ErrorToast("Ocurrió un error al cargar los Métodos de Pagos.");
                });
            },
        },
        created(){                    
            this.resetValues();
            this.getEstados();
            this.getBancos();
            this.getMetodosPagos();
            this.datosLogin = this.$session.get("usuario");
            this.rol = this.datosLogin.rol.name;
        }
    }
</script>
<style scoped>
    #RFC {
        text-transform: uppercase !important;
    }
    .subtitulo{
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        color: #1E2245;
    }
</style>